import { create } from 'zustand';

export interface TrackedDocumentWorkflow {
  workflowId: string;
  filename: string;
  documentType: string;
  correlationId: string;
}

interface DocumentWorkflowStore {
  workflows: TrackedDocumentWorkflow[];
  trackWorkflow: (workflow: TrackedDocumentWorkflow) => void;
  removeWorkflow: (workflowId: string) => void;
}

export const useDocumentWorkflowStore = create<DocumentWorkflowStore>((set) => ({
  workflows: [],
  trackWorkflow: (workflow) =>
    set((state) => {
      const existing = state.workflows.find((item) => item.workflowId === workflow.workflowId);
      if (existing) {
        return {
          workflows: state.workflows.map((item) =>
            item.workflowId === workflow.workflowId ? workflow : item
          ),
        };
      }

      return {
        workflows: [...state.workflows, workflow],
      };
    }),
  removeWorkflow: (workflowId) =>
    set((state) => ({
      workflows: state.workflows.filter((workflow) => workflow.workflowId !== workflowId),
    })),
}));
